/* eslint-disable no-trailing-spaces */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */

import Handlebars from 'handlebars';
import * as Api from './api';
import * as utils from './utils';
import {loadNotifications} from '../../views/widgets/notifications/js/loadWg';

const CLS_LIST_ADDED = 'has-added';
const CLS_HIDE = 'invisible';
const $loadingSpinner = $('.loading-spinner');

/**
 * @description add item to wishlist
 * @param $pg - Page jquery object
 * @param $btn - Button 'add to my list' jquery object
 * @param endpoint - url enpoint
 * @param param - object contains parameter for API call like 'id'
 * @param addedCB - optional callback function called after success
*/
export function add($pg, $btn, endpoint, param, addedCB) {
    // console.log('wishilist.add', param);
	return new Promise((resolve, reject) => {
		if (!endpoint) {
			console.warn(`addToWishlist. Please supply endpoint variable. Returned early;`);
			return;
		}

		if (!$pg) {
			console.warn(`addToWishlist. Please supply $pg variable. Returned early;`);
			return;
		}

		// toggle spinners, remove errors
		$pg.find('.error-messages.add-to-cart-errors').removeClass('is-active').text('');
		$loadingSpinner.addClass('is-active');
		let apiParam = {
			code: param.code,
			quantity: param.qty,
		};

		addToListCall(endpoint, apiParam).then((response) => {
			if (response && response.result === 'SUCCESS') {
				let res = response.response;
				$btn.addClass(CLS_LIST_ADDED);
				updateCounter(res.wishlistCount);
				if (addedCB) addedCB(response);

				// show popper
				let details = {
					mods: response.message ? 'has-error' : '',
					addedText: 'Added to wishlist',
					qty: response.quantityActual,
					errorMsg: response.message,
					itemImg: window.itemImg,
					title: window.itemTitle,
				};
				showPopper(details);
				resolve(response.lineItemId);
			} else {
				// show error div
				$pg.find('.error-messages.add-to-cart-errors').addClass('is-active').text(response.message);
				resolve();
			}

			$loadingSpinner.removeClass('is-active');
		});

		function addToListCall(endpoint, $data) {
			return Api.callApi(endpoint, $data);
		}
	});
}

export function remove($pg, $btn, endpoint, param, removedCB) {
    // console.log('wishlist.remove', param);

    if (!endpoint) {
        console.warn(`removeFromWishlist. Please supply endpoint variable. Returned early;`);
        return;
    }

    if (!$pg) {
        console.warn(`removeFromWishlist. Please supply $pg variable. Returned early;`);
        return;
    }

    $pg.find('.error-messages.add-to-cart-errors').removeClass('is-active').text('');
    $loadingSpinner.addClass('is-active');
    let apiParam = {
        id: param.code,
    };

    removeFromListCall(endpoint, apiParam).then((response) => {
        if (response && response.result === 'SUCCESS') {
            let res = response.response;
            $btn.removeClass(CLS_LIST_ADDED);
            updateCounter(res.lineitemscount);
            if (removedCB) removedCB(response);
        } else {
            $pg.find('.error-messages.add-to-cart-errors').addClass('is-active').text(response.message);
        }

        $loadingSpinner.removeClass('is-active');
    });

    function removeFromListCall(endpoint, $data) {
        return Api.callApi(endpoint, $data);
    }
}

export function updateCounter(count) {
	let $wishlist;
	if ($('.siteHeader').hasClass('desktop-menu-2022')) {
		$wishlist = $('.js-wishlist');
	} else {
		$wishlist = $('.siteHeader-wishlist');
	}

    if ($wishlist.length === 0) return;
	let $count = $wishlist.find('.siteHeader-cartCount');

    if (count == 0) {
        $count.addClass(CLS_HIDE);
    } else {
        $count.removeClass(CLS_HIDE);
    }

    $count.html(count);
}

export function moveToCart($wg, endpoint, param, movedCB) {
    if (!endpoint) {
        console.warn(`moveToCart. Please supply endpoint variable. Returned early;`);
        return;
    }

    if (!$wg) {
        console.warn(`moveToCart. Please supply $pg variable. Returned early;`);
        return;
    }

    $wg.find('.error-messages').removeClass('is-active').text('');
    $loadingSpinner.addClass('is-active');

    moveToCartCall(endpoint, param).then((response) => {
        if (response && response.result === 'SUCCESS') {
            let res = response.response;
            updateCounter(res.wishlistCount);
            if (movedCB) movedCB(response);
        } else {
            $wg.find('.error-messages').addClass('is-active').text(response.message);
        }

        $loadingSpinner.removeClass('is-active');
    });

    function moveToCartCall(endpoint, $data) {
        return Api.callApi(endpoint, $data);
    }
}

export function moveAllToCart($pg, endpoint, movedCB) {
    if (!endpoint) {
        console.warn(`moveAllToCart. Please supply endpoint variable. Returned early;`);
        return;
    }

    if (!$pg) {
        console.warn(`moveAllToCart. Please supply $pg variable. Returned early;`);
        return;
    }

    $pg.find('.wishlistPage-error').removeClass('is-active').text('');
    $loadingSpinner.addClass('is-active');

    moveAllCall(endpoint).then((response) => {
        if (response && response.result === 'SUCCESS') {
            let res = response.response;
            updateCounter(res.wishlistCount);
            if (movedCB) movedCB(response);
        } else {
            $pg.find('.wishlistPage-error').addClass('is-active').text(response.message);
        }

        $loadingSpinner.removeClass('is-active');
    });

    function moveAllCall(endpoint) {
        return Api.callApi(endpoint);
    }
}

export function updateQuantity($wg, endpoint, param, updatedCB) {
    // console.log('wishilist.add', param);

    if (!endpoint) {
        console.warn(`addToWishlist. Please supply endpoint variable. Returned early;`);
        return;
    }

    if (!$wg) {
        console.warn(`addToWishlist. Please supply $wg variable. Returned early;`);
        return;
    }

    // toggle spinners, remove errors
    $wg.find('.error-messages').removeClass('is-active').text('');
    $loadingSpinner.addClass('is-active');
    let apiParam = {
        id: param.id,
        quantity: param.quantity,
    };

    updateQuantityCall(endpoint, apiParam).then((response) => {
        if (response && response.result === 'SUCCESS') {
            let res = response.response;
            updateCounter(res.lineitemscount);
            if (updatedCB) updatedCB(response);
        } else {
            // show error div
            $wg.find('.error-messages').addClass('is-active').text(response.message);
        }

        $loadingSpinner.removeClass('is-active');
    });

    function updateQuantityCall(endpoint, $data) {
        return Api.callApi(endpoint, $data);
    }
}

function showPopper(data) {
    // register the template
    let partial = require('../../views/widgets/notifications/tmpl/notifications.hbs');
    Handlebars.registerPartial('notifications', partial);
    let theTemplateScript = `
        {{> notifications wg="notifications" ns="Notifications" }}
    `;
    let precompiled = new Function('return ' + Handlebars.precompile(theTemplateScript))();
    let theTemplate = Handlebars.template(precompiled);
    let theCompiledHtml = theTemplate(data);
    $(document).find('body').append(theCompiledHtml);
    // Re-init script for notifications widget
    loadNotifications(document.body, false, true).then((wg) => {
        wg ? wg.init() : '';
    }).catch((error) => `${error} An error occurred while loading notifications script`);
}



// WEBPACK FOOTER //
// ./wishlist.js